import { Component, ElementRef, Input } from '@angular/core';
import { HelpConfig } from './models/help-icon.interfaces';

@Component({
  selector: 'idp-help-icon',
  templateUrl: './help-icon.component.html',
  styleUrls: ['./help-icon.component.scss']
})
export class HelpIconComponent {
  @Input() modalContent = '';
  @Input() modalTitle = 'Locating a Ticket Number';
  @Input() hideCloseButton = false;
  @Input() closeButtonLabel = 'Close';
  @Input() closeOnBackgroundClick = false;
  @Input() srText = 'Ticket help';
  @Input() modalStyle = 'slim';
  @Input() labelIcon = false;
  @Input() helpIcon = false;
  @Input() modalType = ' ';
  @Input() tooltip = false;
  @Input() infoToolTip = false;
  @Input() tooltipContent = '';
  @Input() arrowPosition = 'right';
  @Input() modalTemplate = false;
  @Input() showCloseIconToolTip = true;
  @Input() closeEscInfoToolTip = false;
  @Input() config: HelpConfig = {} as HelpConfig;

  open = false;
  enableTooltip = false;

  constructor(private elementRef: ElementRef) {}

  /** Open the pop up */
  openModal() {
    // Adjust Margin Top is case of Virgin
    const banner = document.querySelector('.alert-advisory-main-container');
    if (banner !== null) {
      this.modalStyle += ' addMarginTop';
    }
    // End
    if (this.open) {
      this.closeModal();
    } else {
      this.open = true;
    }
  }

  /** Close the pop up */
  closeModal() {
    this.open = false;
    this.setFocusOnHelp();
  }

  /** Open the tooltip */
  openTooltip() {
    this.enableTooltip = true;
  }

  /** Close the tooltip */
  closeTooltip() {
    this.enableTooltip = false;
    if (this.showCloseIconToolTip) {
      this.setFocusOnHelp();
    }
  }

  /** Trap the focus within pop up while it is open */
  tabHandler(event: Event, fromCloseButton = false) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.stopPropagation();
    keyboardEvent.preventDefault();
    if (keyboardEvent.key === 'Tab') {
      if (keyboardEvent.shiftKey) {
        this.setFocusOnClose(fromCloseButton);
      } else {
        this.setFocusOnModal();
      }
    }
  }

  /** Close the tooltip when showCloseIconTooltip is true */
  closeTooltipPopup(
    showCloseIconToolTip: boolean,
    closeEscInfoToolTip: boolean
  ) {
    if (showCloseIconToolTip || closeEscInfoToolTip) {
      this.closeTooltip();
    } else {
      this.enableTooltip = true;
    }
  }

  /** Utility method to set focus of the element passed to it */
  setFocus(element: HTMLElement) {
    if (!element) {
      return;
    }
    element.focus();
  }

  /** To set focus on modal while reverse tabbing from close icon */
  closeIconReverseTab(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.stopPropagation();
    keyboardEvent.preventDefault();
    if (keyboardEvent.key === 'Tab' && keyboardEvent.shiftKey) {
      this.setFocusOnModal();
    }
  }

  /** To set focus on the modal */
  setFocusOnModal() {
    this.setFocus(
      this.elementRef.nativeElement.querySelector(
        '.idp-dialog.slim .idp-simple-modal__body.idp-dialog__body'
      )
    );
  }

  /** To set focus of the help icon */
  setFocusOnHelp() {
    this.setFocus(
      this.elementRef.nativeElement.querySelector('a.idp-icon-info-anchor')
    );
  }

  /*** To set focus on close icon/button depending on "fromCloseButton" flag. If "fromCloseButton" is true, focus is set on the close icon. If "fromCloseButton" is false, focus is set on the close button in the footer of the modal*/
  setFocusOnClose(fromCloseButton = true) {
    if (fromCloseButton) {
      this.setFocus(
        this.elementRef.nativeElement.querySelector('.idp_dialog__close')
      );
    } else {
      this.setFocus(
        this.elementRef.nativeElement.querySelector('#closeButton')
      );
    }
  }

  /** Sets classes for the close button wrapper */
  setCloseButtonClasses() {
    return {
      'close-button__wrapper': true,
      'close-button__wrapper--shift': this.modalType === 'confirmationNumber',
      'close-button__wrapper--fixed': this.modalType === 'ticketNumber'
    };
  }
}
